'use client';

import React from "react";
import AnimatedLogo from "./AnimatedLogo";

function Loader() {
  return (
    <>
      <AnimatedLogo
        className="fixed top-[50vh] left-[50vw] -translate-x-1/2 -translate-y-1/2 opacity-50"
        height="40vh"
        width="40vw"
      />
      <div className="relative h-lvh opacity-10 ">
        {/* First div */}
        <div
          className="absolute top-10 right-10 -rotate-45 w-[350px] h-[200px] bg-[radial-gradient(circle,_var(--accent-dark),_#0000)] blur-3xl animate-move"
          style={{ "--move-direction": "move1" }}
        ></div>

        {/* Second div */}
        <div
          className="absolute top-1/4 left-1/4 -rotate-45 w-[350px] h-[200px] bg-[radial-gradient(circle,_var(--accent-2),_var(--accent-dark),_#0000)] blur-3xl animate-move"
          style={{ "--move-direction": "move2" }}
        ></div>

        {/* Third div */}
        <div
          className="absolute top-10 left-20 -rotate-45 w-[350px] h-[200px] bg-[radial-gradient(circle,_var(--accent-dark),_#0000)] blur-3xl animate-move"
          style={{ "--move-direction": "move3" }}
        ></div>

        {/* Fourth div */}
        <div
          className="absolute bottom-1/4 right-1/4 -rotate-45 w-[350px] h-[200px] bg-[radial-gradient(circle,_var(--accent-dark),_#0000)] blur-3xl animate-move"
          style={{ "--move-direction": "move4" }}
        ></div>

        {/* Fifth div */}
        <div
          className="absolute bottom-10 left-1/5 -rotate-45 w-[350px] h-[200px] bg-[radial-gradient(circle,_var(--accent-2),_var(--accent-dark),_#0000)] blur-3xl animate-move"
          style={{ "--move-direction": "move5" }}
        ></div>
      </div>
    </>
  );
}

export default Loader;
